<div class="container m-0 p-0">
  <div class="row">
    <div class="col dialog-title">New {{ header }}</div>
  </div>
  <div class="row">
    <div class="col dialog-content">
      <div [formGroup]="form">
        <div class="modal__item row">
          <label
            class="label-input col-3"
            appMarkAsterisk
            [formGroup]="form"
            [controlName]="'name'"
            [touched]="form.get('name')!.touched"
            >Name</label
          >
          <div class="col-9 modal-validation">
            <input
              type="text"
              class="input__basic"
              placeholder=" "
              formControlName="name"
            />
            <app-error-field
              [displayError]="
                isFieldInvalid('name', form) &&
                form.get('name')!.hasError('required')
              "
              [errorMessage]="'The field is required'"
            ></app-error-field>
            <app-error-field
              [displayError]="form.get('name')!.hasError('maxlength')"
              [errorMessage]="'Max field length = 20'"
            ></app-error-field>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row align-items-center justify-content-end dialog-buttons">
    <div class="col-auto p-0 mb-3">
      <button class="button button__save add-margin" (click)="saveData()">
        Save
      </button>
      <button class="button button__cancel" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>
